import React, { useRef, useState } from 'react';
import { media_url } from '../../hooks/useBlog';
import './NewsVideoCarousel.scss';

const NewsVideoCarousel = ({ videos, onVideoClick }) => {
  const scrollRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  const handleScroll = () => {
    const element = scrollRef.current;
    if (element) {
      setShowLeftArrow(element.scrollLeft > 0);
      setShowRightArrow(
        element.scrollLeft < element.scrollWidth - element.clientWidth - 10
      );
    }
  };

  const scroll = (direction) => {
    const element = scrollRef.current;
    if (element) {
      const scrollAmount = 300;
      element.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="news-video-carousel-wrapper">
      {showLeftArrow && (
        <button 
          className="carousel-arrow carousel-arrow-left"
          onClick={() => scroll('left')}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      )}

      <div 
        className="news-video-carousel" 
        ref={scrollRef}
        onScroll={handleScroll}
      >
        {videos.map((video, index) => (
          <div 
            key={video.id} 
            className="news-video-story"
            onClick={() => onVideoClick(index)}
          >
            <div 
              className="news-video-story-thumbnail"
              style={{
                backgroundImage: video.thumbnail 
                  ? `url(${media_url(video.thumbnail)})` 
                  : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
              }}
            >
              <div className="news-video-story-overlay">
                <div className="play-icon">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <circle cx="16" cy="16" r="16" fill="rgba(255, 255, 255, 0.9)"/>
                    <path d="M12 9v14l11-7z" fill="#1a1a1a"/>
                  </svg>
                </div>
              </div>
              <div className="news-video-story-ring"></div>
            </div>
            <div className="news-video-story-info">
              <p className="news-video-story-title">{video.title}</p>
            </div>
          </div>
        ))}
      </div>

      {showRightArrow && (
        <button 
          className="carousel-arrow carousel-arrow-right"
          onClick={() => scroll('right')}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      )}
    </div>
  );
};

export default NewsVideoCarousel;
